






















































































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'

@Component
export default class Home extends Vue {
	data() {
		return {
			title: "Frontend components",
			intro: "Add class to header if needed"
		}
	}
	mounted() {
		new Reveal.revealOnScrollModule()
	}
}
